import { CaregiverRelationHelper } from '../enums/caregiver-relation';
import { EducationLevel } from '../enums/education-level';
import { ProfessionalActivity } from '../enums/professional-activity';
import { User } from './user.entity';

export class Patient extends User {
  public birthDate: Date = null;
  public height: number = null;
  public weight: number = null;
  public educationLevel: EducationLevel = null;
  public professionalActivity: ProfessionalActivity = null;
  public isFullTimeActivity: boolean = null;
  public liveWithCaregiver: boolean = null;
  public caregiverRelation: CaregiverRelationHelper = null;
  public childrenCount: string = '';
  // public msType: MSType = null;
  public canWalkOneKm: string = null;
  public edss: number = null;
  public edssDate: Date = null;
  public diagnosticYear: number = null;
  public firstYearOfSymptoms: number = null;
  public firstYearRelapseCount: number = null;
  public walkingStickAid: boolean = false;
  public crutchesAid: boolean = false;
  public walkWithCaregiverAid: boolean = false;
  public walkerAid: boolean = false;
  public wheelChairAid: boolean = false;
  public geneticRiskFactors: string = '';
  public otherRiskFactors: string = '';
  public dominantHand: string = '';

  public override deserialize(input?: any): Patient {
    super.deserialize(input);

    if (input['characteristics']) {
      const characteristic = input['characteristics'].find(
        (item) => item.characteristicType.code === 'edss'
      );
      if (characteristic) {
        this.edssDate = characteristic.creationDate;
      }
    }

    if (input['birthDate'] !== null && input['birthDate'] !== undefined) {
      this.birthDate = new Date(
        input['birthDate'].split('/').reverse().join('-')
      );
    }

    return this;
  }
}
